import classNames from 'classnames';
import React from 'react';
import './Tabs.scss';
import { isMobileOnly } from 'react-device-detect';

interface TabsHeaderProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
}

export function TabsHeader({ className, children, ...rest }: TabsHeaderProps) {
  return <div className={classNames('TabsHeader', className, isMobileOnly && 'TabsHeaderMobile')} {...rest}>
    {children}
  </div>
}

interface TabButtonProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  active?: boolean
  disabled?: boolean
}

export function TabButton({ className, active, disabled, children, ...rest }: TabButtonProps) {
  return <div className={classNames('TabButton', active && 'active', disabled && 'disabled', className)} {...rest}>
    {children}
  </div>
}
